module.exports = __webpack_public_path__ + "img/palladium.8323210.png";